import { z } from "zod";
export const ObjectMeta = z.object({
    name: z.string().max(150).optional(),
    description: z.string().max(2000).optional(),
});
export function validateDesignSystemVersion(version) {
    const urlCompliantRegex = /^[a-zA-Z0-9+.-]+$/;
    return urlCompliantRegex.test(version);
}
export const DTOCreateVersionInput = z.object({
    meta: ObjectMeta,
    version: z.string().refine(validateDesignSystemVersion, {
        message: "Invalid semantic versioning format",
    }),
    changeLog: z.string().optional(),
});
export const DTOUpdateVersionInput = z.object({
    meta: ObjectMeta,
    version: z.string(), // required for PUT, but not editable
    changeLog: z.string(),
});
